/**
 * Global scroll management
 */

import { barba, PageState } from 'barba'
import scrollToNode from 'utils/scroll-to-node'

const scrollRestorationSupport = 'scrollRestoration' in window.history
const html = document.querySelector('html')
let pageStateScrollY = 0
let timeout = null



/**
 * Save scroll Y to page state every 150 ms (has long has executed)
 */
const savePageStateScrollY = function SavePageStateScrollY() {
    if (timeout !== null) {
        return
    }
    timeout = setTimeout(() => {
        clearTimeout(timeout)
        timeout = null
        window.requestAnimationFrame(() => {
            PageState.set('window-scroll-y', window.scrollY)
        })
    }, 150)
}



/**
 * Retreive scroll Y from page state
 */
const getPageStateScrollY = function GetPageStateScrollY() {
    return PageState.get('window-scroll-y')
}



/**
 * If browser support scroll restoration
 */
if (scrollRestorationSupport) {

    // Scroll restoration to manual
    window.history.scrollRestoration = 'manual'

    // Before unload, scroll restoration to auto.
    // This allow the browser to have the correct scroll
    // position on page refresh.
    window.onbeforeunload = (e) => {
        window.history.scrollRestoration = 'auto'
    }

    // On popstate, get scroll
    window.addEventListener('popstate', e => {
        pageStateScrollY = getPageStateScrollY()
    })

    // On window event, save scroll
    window.addEventListener('scroll', savePageStateScrollY)
    window.addEventListener('resize', savePageStateScrollY)
}



/**
 * Custom anchor behavior
 * 
 * There is conflict if a Barba transition named "self" exist.
 * If a "self" transition exit, an anchor link will
 * transition like any other page.
 */
html.addEventListener('click', e => {
    const anchor = e.target.closest('a[href^="#"]')

    if (!anchor) {
        return
    }

    e.preventDefault()
    e.stopPropagation()

    const id = anchor.getAttribute('href').trim()

    if (id === "#") {
        window.requestAnimationFrame(() => window.scrollTo(0, 0))
        return
    }

    const node = document.querySelector(id)

    if (node) {
        window.requestAnimationFrame(() => scrollToNode(node))
    }
})



/**
 * If there is an hash on page load, scroll to 
 */
if (location.hash && location.hash.trim !== "#") {
    const node = document.querySelector(location.hash)
    if (node) {
        window.requestAnimationFrame(() => scrollToNode(node))
    }
}



/**
 * Barba "before" transition
 */
barba.hooks.before(() => {
    // Disable page smooth scrolling
    html.style.scrollBehavior = "auto"
})



/**
 * Barba "enter" transition
 * Set the scroll position based on trigger and URL pattern
 */
barba.hooks.enter(data => {
    const { trigger, next } = data

    // Popstate navigation
    if (typeof trigger === "string" && (trigger === "back" || trigger === "forward" || trigger === "popstate")) {
        // Browser doesn't support scroll restoration, default behavior
        if (!scrollRestorationSupport) {
            return
        }
        // Scroll to page state scroll Y position
        if (pageStateScrollY !== null) {
            window.scrollTo(0, pageStateScrollY)
            return
        }
        // Default
        window.scrollTo(0, 0)
        return
    }

    // Scroll to hash position
    let node = null
    if (next.url && next.url.hash) {
        node = next.container.querySelector(`#${next.url.hash}`)
    }
    if (node) {
        scrollToNode(node)
        return
    }

    // Scroll to top
    window.scrollTo(0, 0)

})



/**
 * Barba "afterEnter" transition
 */
barba.hooks.afterEnter(() => {
    // Restore default CSS scroll behavior smooth
    html.style.scrollBehavior = "smooth"
    // Save initial scroll position
    !scrollRestorationSupport || savePageStateScrollY()
})